'use client';

import {
  HomeIcon,
  CalendarDaysIcon,
  UserIcon,
  UserGroupIcon,
  AcademicCapIcon,
  BookOpenIcon,
  DocumentMagnifyingGlassIcon,
  EyeIcon,
  MagnifyingGlassIcon,
  ClipboardDocumentCheckIcon,
  ClockIcon,
  StarIcon,
  QuestionMarkCircleIcon,
  ChatBubbleLeftRightIcon,
  MapPinIcon,
  TruckIcon,
  BuildingOffice2Icon,
  BeakerIcon,
  InformationCircleIcon,
  CircleStackIcon,
  MegaphoneIcon,
  TicketIcon,
  CreditCardIcon,
  LightBulbIcon,
  DocumentTextIcon,
  SparklesIcon,
  Cog6ToothIcon,
  CommandLineIcon,
  CalculatorIcon,
} from '@heroicons/react/24/outline';
import type { IconComponent } from '@/app/lib/search/types';
import { DiningIcon, TargetIcon } from '@/app/Components/AcademicIcons';

export const SEARCH_ICON_MAP: Record<string, IconComponent> = {
  TargetIcon,
  DiningIcon,
  HomeIcon,
  CalendarDaysIcon,
  UserIcon,
  UserGroupIcon,
  AcademicCapIcon,
  BookOpenIcon,
  DocumentMagnifyingGlassIcon,
  EyeIcon,
  MagnifyingGlassIcon,
  ClipboardDocumentCheckIcon,
  ClockIcon,
  StarIcon,
  QuestionMarkCircleIcon,
  ChatBubbleLeftRightIcon,
  MapPinIcon,
  TruckIcon,
  BuildingOffice2Icon,
  BeakerIcon,
  InformationCircleIcon,
  CircleStackIcon,
  MegaphoneIcon,
  TicketIcon,
  CreditCardIcon,
  LightBulbIcon,
  DocumentTextIcon,
  SparklesIcon,
  Cog6ToothIcon,
  CommandLineIcon,
  CalculatorIcon,
};

export function SearchIcon({
  iconId,
  className = 'w-5 h-5',
}: {
  iconId?: string;
  className?: string;
}) {
  const Icon = iconId ? SEARCH_ICON_MAP[iconId] : MagnifyingGlassIcon;
  const Resolved = Icon ?? MagnifyingGlassIcon;
  return <Resolved className={className} aria-hidden />;
}
